module.exports = __webpack_public_path__ + "img/butterfly.7bd19b11.gif";